export default "__VITE_ASSET__CgyT9cJA__"